export var CUSTOM_FIELDS_ENTITY_TYPE_PO_LINE = 'po_line';
